(function ($) {
    var $fn = $(".comp_my_provisions");

    if ($fn.length) {

    }
})(jQuery);